export default __webpack_public_path__ + "static/media/nvme.cd22a054.png";